/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { pt2px as e } from "../../../../core/screenUtils.js";
import "../../../../libs/maquette/projection.js";
import { createProjector as t } from "../../../../libs/maquette/projector.js";
import { renderColorRampPreviewHTML as o } from "../../../../symbols/support/symbolUtils.js";
import "../../../support/widgetUtils.js";
import { tsx as i } from "../../../support/jsxFactory.js";
const l = t(),
  n = 10,
  r = 20,
  s = 10,
  a = 20,
  c = {
    univariateAboveAndBelowSymbol: "esri-univariate-above-and-below-ramp__symbol",
    colorRamp: "esri-legend__color-ramp"
  };
function f(e = "vertical") {
  const t = "stroke:rgb(200, 200, 200);stroke-width:1";
  return "vertical" === e ? i("svg", {
    height: "4",
    width: "10"
  }, i("line", {
    style: t,
    x1: "0",
    x2: "10",
    y1: "2",
    y2: "2"
  })) : i("svg", {
    height: "10",
    width: "10"
  }, i("line", {
    style: t,
    x1: "5",
    x2: "5",
    y1: "0",
    y2: "10"
  }));
}
function p(e, t = "vertical") {
  const o = document.createElement("div");
  return o.style.height = `${r}px`, o.className = c.univariateAboveAndBelowSymbol, null != e && (o.style.opacity = e.toString()), l.append(o, f.bind(null, t)), o;
}
function m(t, o, i = "vertical", l) {
  t.infos.forEach((t, n) => {
    if (l && 2 === n) t.preview = p(o, i);else {
      const o = e(t.size) + ("horizontal" === i ? a : s),
        l = t.preview,
        n = "div" === l?.tagName.toLowerCase(),
        r = n ? l : document.createElement("div");
      r.className = c.univariateAboveAndBelowSymbol, "horizontal" === i ? r.style.width = `${o}px` : r.style.height = `${o}px`, !n && l && r.appendChild(l), t.preview = r;
    }
  });
}
function u(t, o = "classic") {
  const i = t.infos;
  return "classic" === o ? (e(i[0].size) + s) / 2 : (e(i[0].size) - e(i[i.length - 1].size)) / 2;
}
function h(e, t) {
  if (!e) return null;
  const i = e.infos.map(e => e.color),
    l = o("full" === t.type ? i : "above" === t.type ? i.slice(0, 3) : i.slice(2, 5), {
      width: t.width,
      height: t.height,
      align: t.rampAlignment,
      effectList: t.effectList,
      ariaLabel: t.ariaLabel
    });
  return l.className = c.colorRamp, null != t.opacity && (l.style.opacity = t.opacity.toString()), l;
}
function v(t, o, i, l = "vertical") {
  let c = 0;
  const f = t.infos,
    p = Math.floor(f.length / 2),
    m = "full" === o || "above" === o ? 0 : p,
    u = "full" === o || "below" === o ? f.length - 1 : p;
  for (let h = m; h <= u; h++) if (i && h === p) c += "horizontal" === l ? n : r;else {
    c += e(f[h].size) + ("horizontal" === l ? a : s);
  }
  return Math.round(c);
}
function y(t, o, i, l = "vertical") {
  const c = v(t, o, i, l),
    f = t.infos,
    p = Math.floor(f.length / 2),
    m = "full" === o || "above" === o ? 0 : p,
    u = "full" === o || "below" === o ? f.length - 1 : p,
    h = "full" === o ? f[m].size + f[u].size : "above" === o ? f[m].size : f[u].size,
    y = i ? "vertical" === l ? r : n : 0,
    d = "vertical" === l ? s * ("full" === o ? 2 : 1) : a * ("full" === o ? 2 : 1);
  return Math.round(c - (e(h) / 2 + y / 2 + d / 2));
}
function d(e, t, o = "vertical") {
  const i = e.infos;
  let l = i.find(({
      type: e
    }) => "size-ramp" === e),
    n = i.find(({
      type: e
    }) => "color-ramp" === e);
  return l && (l = {
    ...l
  }, l.infos = [...l.infos], m(l, t, o, !0)), n && (n = {
    ...n
  }, n.infos = [...n.infos]), "horizontal" === o && (l?.infos.reverse(), n?.infos.reverse()), {
    sizeRampElement: l,
    colorRampElement: n
  };
}
function b(e, t = "vertical") {
  const o = e.infos;
  let i = o.find(({
      type: e
    }) => "size-ramp" === e),
    l = o.find(({
      type: e
    }) => "color-ramp" === e);
  return i && (i = {
    ...i
  }, i.infos = [...i.infos], m(i, null, t, !1)), l && (l = {
    ...l
  }, l.infos = [...l.infos]), "horizontal" === t && (i?.infos.reverse(), l?.infos.reverse()), {
    sizeRampElement: i,
    colorRampElement: l
  };
}
export { d as getUnivariateAboveAndBelowRampElements, u as getUnivariateColorRampMargin, h as getUnivariateColorRampPreview, y as getUnivariateColorRampSize, b as getUnivariateColorSizeRampElements, v as getUnivariateSizeRampSize };